import React from 'react';
import cn from 'classnames';
import { findByType } from '../utils';
import { Link } from '../components/Link';
import './LinksBlock.scss';
export function LinksBlock({ data }) {
    var _a, _b, _c;
    const analytics = (_a = findByType(data.value.config, 'analytics_label')) === null || _a === void 0 ? void 0 : _a.value;
    const color = (_c = (_b = findByType(data.value.config, 'color')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 'white';
    const colorClass = `color-${color}`;
    return React.createElement("div", { className: cn('content-block-links', colorClass), "data-analytics-nav": analytics }, data.value.links.map((action, i) => React.createElement(Link, { key: i, link: action })));
}
